var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      staticClass: "modalInformacao",
      attrs: { titulo: "Solicitar Acesso", width: _vm.width, isDespacho: true },
      on: {
        closeModal: function($event) {
          return _vm.closeModal()
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _vm.showModalVisualizaPdf
            ? _c("app-modal-visualiza-pdf", {
                attrs: {
                  titulo: _vm.tituloModal,
                  tipo: _vm.tipoModal,
                  conteudo: _vm.conteudoModal,
                  isVTN: false,
                  isImagem: _vm.isImagem,
                  tituloDocumento: _vm.tituloDocumento
                },
                on: { closeModal: _vm.closeModalVisualizaPdf }
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "extra-margin-top" },
            [
              _c(
                "validation-observer",
                { ref: "validation", attrs: { tag: "form" } },
                [
                  _c(
                    "el-row",
                    { staticClass: "margin-top" },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("app-label", {
                            staticClass: "mt-20",
                            attrs: { label: "Justificativa:", required: true }
                          }),
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("app-editor-texto", {
                                      ref: "editorTexto",
                                      staticClass: "input",
                                      class: { erro: errors.length },
                                      attrs: { value: _vm.mensagem },
                                      on: { onTextChange: _vm.onTextChange }
                                    }),
                                    errors.length
                                      ? _c(
                                          "span",
                                          { staticClass: "help erro" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("el-row", { staticClass: "margin-top" }, [
                    _c("p", { staticClass: "label mt-20" }, [
                      _vm._v("Anexos mensagem")
                    ])
                  ]),
                  _c(
                    "el-row",
                    { staticClass: "margin-top" },
                    [
                      _c("validation-provider", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-anexo", {
                                  attrs: {
                                    id: "upload-informacao-solicitar",
                                    files: _vm.anexos,
                                    scope: "anexos",
                                    errors: errors,
                                    exibirDownload: false
                                  },
                                  on: {
                                    removeFile: _vm.removeFile,
                                    uploadFile: _vm.uploadFile
                                  },
                                  model: {
                                    value: _vm.anexos,
                                    callback: function($$v) {
                                      _vm.anexos = $$v
                                    },
                                    expression: "anexos"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "default", size: "small" },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                }
              },
              [
                _c("span", { staticClass: "center" }, [
                  _c("i", { staticClass: "fa fa-times" }),
                  _c("b", [_vm._v("  Cancelar")])
                ])
              ]
            ),
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "success", size: "small" },
                on: {
                  click: function($event) {
                    return _vm.sendMessage()
                  }
                }
              },
              [
                _c("span", { staticClass: "center" }, [
                  _c("i", { staticClass: "fa fa-share-square" }),
                  _c("b", [_vm._v("  Enviar")])
                ])
              ]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a63a0734", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a63a0734","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/acompanharProcessos/components/AppModalSolicitarAcesso.vue
// module id = null
// module chunks = 